import { offset } from "@floating-ui/dom"

export const ELEMENT_READY_TIMEOUT_MS = 10000

/**
 * Resolves once `selector` matches an element in the DOM.
 *
 * Always resolves - never rejects. If the element never appears we resolve with
 * `null` after `timeoutMs` so a stale selector degrades to "show the step
 * anyway" instead of hanging the tour behind its modal overlay forever.
 */
export function elementReady(
  selector: string,
  timeoutMs: number = ELEMENT_READY_TIMEOUT_MS
) {
  return new Promise<globalThis.Element | null>((resolve) => {
    const el = document.querySelector(selector)
    if (el) {
      resolve(el)
      return
    }

    const observer = new MutationObserver(() => {
      // Query for elements matching the specified selector
      const match = document.querySelector(selector)
      if (match) {
        //Once we have resolved we don't need the observer anymore.
        observer.disconnect()
        clearTimeout(timer)
        resolve(match)
      }
    })

    const timer = setTimeout(() => {
      observer.disconnect()
      resolve(null)
    }, timeoutMs)

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    })
  })
}

export const tourOptions = {
  defaultStepOptions: {
    cancelIcon: {
      enabled: false,
    },
  },
  useModalOverlay: true,
  exitOnEsc: false,
}

export const defaults = {
  buttons: [
    {
      classes: "shepherd-button-primary",
      text: "Next",
      type: "next",
    },
  ],
  floatingUIOptions: {
    middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
  },
  modalOverlayOpeningPadding: 5,
  modalOverlayOpeningRadius: 5,
}
